import * as React from 'react';

import PropTypes from 'prop-types';

import LegacyCourseEnrollButton from 'bundles/enroll-course/components/LegacyCourseEnrollButton';
import userIdentity from 'bundles/phoenix/template/models/userIdentity';
import productOwnershipPromise from 'bundles/product/promises/productOwnership';

class PhoenixEnrollButton extends React.Component {
  static propTypes = {
    redirectUrlAfterAuth: PropTypes.string,
  };

  static contextTypes = {
    course: PropTypes.object.isRequired,
  };

  state = {
    shouldShow: false,
    ownsCourse: false,
  };

  componentDidMount() {
    if (userIdentity.get('authenticated')) {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
      productOwnershipPromise(userIdentity.get('id'), this.context.course.get('id'))
        .then((productOwnership) => this.setState({ ownsCourse: productOwnership.get('owns') }))
        .finally(() => this.setState({ shouldShow: true }));
    } else {
      this.setState({ shouldShow: true });
    }
  }

  render() {
    if (!this.state.shouldShow) {
      return null;
    }

    const elClassName = 'rc-PhoenixEnrollButton';
    const { course } = this.context;

    return <LegacyCourseEnrollButton courseId={course.get('id')} className={elClassName} />;
  }
}

export default PhoenixEnrollButton;
